import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  MatSliderDragEvent,
  MatSlider,
  MatSliderRangeThumb
} from '@angular/material/slider';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrl: './range-slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSlider, MatSliderRangeThumb, FormsModule, ReactiveFormsModule]
})
export class RangeSliderComponent {
  minFormControl = input.required<FormControl<number | null>>();
  maxFormControl = input.required<FormControl<number | null>>();

  min = input<number>();
  max = input<number>();
  step = input<number>(1);

  minAriaLabel = input<string>();
  maxAriaLabel = input<string>();

  /**
   * Renders the thumb labels as something other than the raw number, e.g. a
   * letter score. A formatted range is shown as-is: the `+` suffix that marks
   * an open-ended numeric maximum would read as "A+".
   */
  valueFormatter = input<(value: number) => string>();

  /** Arrow property so it keeps its `this` when handed to `displayWith`. */
  format = (value: number): string => {
    const formatter = this.valueFormatter();
    return formatter ? formatter(value) : `${value}`;
  };

  /**
   * When the user stops dragging and leaves the nobs with the cursor,
   * the number bubbles should be hidden
   * @param event
   */
  dragEnd(event: MatSliderDragEvent) {
    event.source._isFocused = false;
  }
}
